import { combineReducers } from "redux";

import catalog from "./catalog";
import templates from "./templates";

export default combineReducers({
	catalog,
	templates,
});
